import Vue from 'vue';
import Router from 'vue-router';
import store from './store/store';
import axios from 'axios';

/* Shared */
import WorldSpiaggeLogin from '../../../world/spa/components/WorldSpiaggeLogin.vue';
import Restaurants from './views/Restaurants.vue';
import Settings from './views/Settings.vue';
import Help from './views/Help.vue';
import ViewOrder from './views/ViewOrder.vue';
/* Employee */
import FastCash from './views/employee/FastCash.vue';
import TakeOrder from './views/employee/TakeOrder.vue';
import Orders from './views/employee/Orders.vue';
import Tables from './views/employee/Tables.vue';
import Inventory from './views/employee/Inventory.vue';
import InventoryC from './views/employee/InventoryC.vue';
import Analytics from './views/employee/Analytics.vue';
/* Customer */
import History from './views/customer/History.vue';
import ViewMenu from './views/customer/ViewMenu.vue';
import PlaceOrder from './views/customer/PlaceOrder.vue';

Vue.use(Router);

const localLogout = async app => {
  app.$anm22.setCookie('com-anm22-food-license', '', -1);
  await app.$vlfClearDb();
}

// Utilizzato per gestire lo scrolling in caso di navigazione back/forward
const scrollBehavior = (to, from, savedPosition) => {
  let position = {};
  if (savedPosition) {
    return savedPosition;
  } else {
    position.x = 0;
    position.y = 0;
    return position;
  }
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior,
  routes: [
    {
      name: 'index',
      path: '/',
      /* Usiamo beforeEnter altrimenti il beforeEach per il settaggio della licenza con cookie viene saltato */
      beforeEnter: (to, from, next) => {
        // Valutare la redirezione alla mappa invece della lista dipendentemente dal cookie di rilevamento app
        if(!store.getters['getLicense']) {
          next('/restaurants');
        } else {
          //Redirect based on customer & cookie setting
          const userId = store.state.auth.userLogged ? store.state.auth.user.idWorldUser : 0;
          if(!userId) {
            next('/order'); 
            return;
          }
          const license = store.getters['foodLicenses/getByHash'](store.getters['getLicense']);
          if(!(userId && license)) {
            next('/restaurants');
            return;
          }
          const employment = store.getters['foodEmployments/get'](license.id + '-' + userId);
          // customer if not employed in license
          if(!employment) {
            next('/order'); 
            return;
          }
          // If only digital menu redirect to inventory
          if(!license.config.modules.fastCash.enabled) {
            next('/inventory');
            return;
          }
          // If not specified fav home
          if(!router.app.$anm22.getCookie('com_anm22_food_fav_index')) {
            next('/fastCash');
            return;
          }
          switch(router.app.$anm22.getCookie('com_anm22_food_fav_index')) {
            case '1':
              next('/orders');
              break;
            case '2':
              next('/tables');
              break;
            case '3':
              next('/fastCash');
              break;
            default:
              next('/settings');
          }
        }
      },
      // meta: {
      //   skipLogin: true,
      // }
    },
    /* Customer */
    {
      name: 'history',
      path: '/history',
      component: History,
      meta: {
        title: '',
        backHref: '/',
        section: 'history',
      },
      // beforeEnter(to, from, next) {
      //   if(!store.getters['getLicense']) {
      //     next('/restaurants');
      //   } else {
      //     next();
      //   }
      // }
    },
    {
      name: 'placeOrder',
      path: '/order',
      component: PlaceOrder,
      meta: {
        title: '',
        backHref: '',
        section: 'order',
        skipLogin: true,
      },
      beforeEnter(to, from, next) {
        if(!store.getters['getLicense']) {
          next('/restaurants');
        } else {
          next();
        }
      }
    },
    {
      name: 'order',
      path: '/orders/:id',
      component: ViewOrder,
      meta: {
        title: '',
        backHref: '/',
        section: 'order'
      },
      // beforeEnter(to, from, next) {
      //   if(!store.getters['getLicense']) {
      //     next('/restaurants');
      //   } else {
      //     next();
      //   }
      // }
    },
    {
      name: 'menu',
      path: '/menu',
      component: ViewMenu,
      meta: {
        title: '',
        backHref: '/',
        section: 'menu',
        skipLogin: true,
      },
      beforeEnter(to, from, next) {
        if(!store.getters['getLicense']) {
          next('/restaurants');
        } else {
          next();
        }
      }
    },
    /* Employee */
    {
      name: 'orders',
      path: '/orders',
      component: Orders,
      meta: {
        title: '',
        backHref: '',
        section: 'orders'
      },
      beforeEnter(to, from, next) {
        if(!store.getters['getLicense']) {
          next('/restaurants');
        } else {
          next();
        }
      }
    },
    {
      name: 'fastCash',
      path: '/fastCash/:id?',
      component: FastCash,
      meta: {
        title: '',
        backHref: '',
        section: 'fastCash'
      },
      beforeEnter(to, from, next) {
        if(!store.getters['getLicense']) {
          next('/restaurants');
        } else {
          next();
        }
      }
    },
    {
      name: 'takeOrder',
      path: '/takeOrder/:id?',
      component: TakeOrder,
      meta: {
        title: '',
        backHref: '',
        section: 'fastCash'
      },
      beforeEnter(to, from, next) {
        if(!store.getters['getLicense']) {
          next('/restaurants');
        } else {
          next();
        }
      }
    },
    {
      name: 'tables',
      path: '/tables',
      component: Tables,
      meta: {
        title: '',
        backHref: '',
        section: 'tables'
      },
      beforeEnter(to, from, next) {
        if(!store.getters['getLicense']) {
          next('/restaurants');
        } else {
          next();
        }
      }
    },
    {
      name: 'inventory',
      path: '/inventory',
      component: Inventory,
      meta: {
        title: '',
        backHref: '',
        section: 'inventory'
      },
      beforeEnter(to, from, next) {
        if(!store.getters['getLicense']) {
          next('/restaurants');
        } else {
          next();
        }
      }
    },
    {
      name: 'categories',
      path: '/inventory/categories',
      component: InventoryC,
      meta: {
        title: '',
        backHref: '/inventory',
        section: 'inventory'
      },
      beforeEnter(to, from, next) {
        if(!store.getters['getLicense']) {
          next('/restaurants');
        } else {
          next();
        }
      }
    },
    {
      name: 'analytics',
      path: '/analytics',
      component: Analytics,
      meta: {
        title: '',
        backHref: '',
        section: 'analytics'
      },
      beforeEnter(to, from, next) {
        if(!store.getters['getLicense']) {
          next('/restaurants');
        } else {
          next();
        }
      }
    },
    /* Shared */
    {
      name: 'restaurants',
      path: '/restaurants',
      component: Restaurants,
      meta: {
        title: '',
        backHref: '',
        section: 'restaurants',
      },
    },
    {
      name: 'settings',
      path: '/settings',
      component: Settings,
      meta: {
        title: '',
        backHref: '',
        section: 'settings'
      },
      // beforeEnter(to, from, next) {
      //   if(!store.getters['getLicense']) {
      //     next('/restaurants');
      //   } else {
      //     next();
      //   }
      // }
    },
    {
      name: 'help',
      path: '/help',
      component: Help,
      meta: {
        title: '',
        backHref: '',
        section: 'help'
      },
      beforeEnter(to, from, next) {
        if(!store.getters['getLicense']) {
          next('/restaurants');
        } else {
          next();
        }
      }
    },
    {
      name: 'login',
      path: '/login',
      component: WorldSpiaggeLogin,
      meta: {
        title: 'Login',
        backHref: '',
        section: 'login'
      }
    },
    {
      name: 'logout',
      path: '/logout',
      async beforeEnter(to, from, next) {
        try {
          const response = await axios.post("auth/logout", {}, { 
            baseURL: process.env.VUE_APP_BACK_DOMAIN + process.env.VUE_APP_BACK_BASE_URL + 'spa/controller/',
            withCredentials: true 
          });
          localLogout(router.app);
          store.dispatch('auth/logout');
          location.reload();
        } catch(e) {
          console.log(e);
          router.app.$anm22.eventBus.$emit("world-headbar-show-message", {
            text: this.$anm22.strLang(
              this.lang,
              "There was an error in logout procedure, please try again.",
              "Si è verificato un errore nella procedura di logout, riprovare per favore."
            ),
            type: "alarm"
          });
        }
      }
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
});

router.beforeEach(async (to, from, next) => {
  // Legacy to remove old cookie if present on old domain (www.anm22.it)
  document.cookie = "com-anm22-food-license=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=www.anm22.it;";
  router.app.$Progress.start();
  if(to.query && to.query.license) {
    router.app.$anm22.setCookie('com-anm22-food-license', to.query.license, 86400);
  }
  //Controllo se è stato effettuato il login, uso Axios perchè non posso accedere ancora al plugin
  if (store.state.auth.checkingLogin) {
    axios
      .get("auth/", { 
        baseURL: process.env.VUE_APP_BACK_DOMAIN + process.env.VUE_APP_BACK_BASE_URL + 'spa/controller/',
        withCredentials: true })
      .then(response => {
        if (!response.data.error) {
          //Salvataggio dei dati dell'utente all'interno dello stato
          Promise.all([
            router.app.$vlf('auth').setItem('user', response.data.user),
            //Save locally licenses (employment)
            store.dispatch("foodLicenses/update", {
              vlf: router.app.$vlf("foodLicenses"),
              objs: response.data.licenses
            }),
            store.dispatch("foodEmployments/update", {
              vlf: router.app.$vlf("foodEmployments"),
              objs: response.data.employments
            }),
            store.dispatch("works/update", {
              vlf: router.app.$vlf("works"),
              objs: response.data.works
            }),
            store.dispatch("foodAcs/update", {
              vlf: router.app.$vlf("foodAcs"),
              objs: response.data.foodAcs
            })
          ])
          .then(result => {
            store.dispatch('auth/updateUserInfo', { data: response.data.user, app: router.app });
          })
          .catch(error => {
            console.log(error);
          })
          .finally(() => {
            store.dispatch('auth/endLoginCheck');
            const licenseHash = router.app.$anm22.getCookie('com-anm22-food-license');
            if(licenseHash !== '' && store.getters['foodLicenses/getAll'].find(l => l.licenseHash === licenseHash)) {
              store.dispatch('setLicense', licenseHash);
            } else {
              router.app.$anm22.setCookie('com-anm22-food-license', '', -1);
            }
            if(to.fullPath === '/login') {
              next('/');
            } else {
              next();
            }
          });
        } else {
          store.dispatch('auth/endLoginCheck');
          const licenseHash = router.app.$anm22.getCookie('com-anm22-food-license');
          if(to.meta.skipLogin && licenseHash) {
            store.dispatch('setLicense', licenseHash);
            next();
          } else {
            // localLogout(router.app);
            if(to.path === '/login') {
              next();
            } else {
              next('/login?cb='+encodeURIComponent(to.fullPath));
            }
          }
        }
      })
      .catch(error => {
        console.log(error);
        if (!error.status) {
          // Offline -> check local storage
          Promise.all([
            router.app.$vlf('auth').getItem('user'),
            store.dispatch("foodLicenses/load", router.app.$vlf("foodLicenses")),
            store.dispatch("foodEmployments/load", router.app.$vlf("foodEmployments")),
            store.dispatch("works/load", router.app.$vlf("works")),
            store.dispatch("foodAcs/load", router.app.$vlf("foodAcs"))
          ])
          .then(result => {
            store.dispatch('auth/updateUserInfo', { data: result[0], app: router.app });
          })
          .catch(error => {
            console.log(error);
          })
          .finally(() => {
            store.dispatch('auth/endLoginCheck');
            const licenseHash = router.app.$anm22.getCookie('com-anm22-food-license');
            if(licenseHash !== '' && store.getters['foodLicenses/getAll'].find(l => l.licenseHash === licenseHash)) {
              store.dispatch('setLicense', licenseHash);
            } else {
              router.app.$anm22.setCookie('com-anm22-food-license', '', -1);
            }
            if(to.meta.skipLogin) {
              next();
            } else {
              if(to.fullPath === '/login') {
                next('/');
              } else {
                next();
              }
            }
          });
        }
      });
  } else {
    next();
  }
});

//Nel caso di informazioni statiche, vengono settate qui, altrimenti nei singoli componenti avvengono ulteriori
//elaborazioni
router.afterEach((to, from) => {
  document.title = to.meta.title;
  // Modifica l'etichetta dell'headbar
  if(to.path !== '/'){
    store.dispatch('headbar/setHeadbarTitle', to.meta.title);
  }
  // Controllo e setto l'eventuale back href
  store.dispatch('headbar/setBackHref', to.meta.backHref);
  // Setto la voce del menu di navigazione da selezionare
  store.dispatch('menu/setSelected', to.meta.section);
});

export default router;
